import useTranslation from 'next-translate/useTranslation'
import React from 'react'
import { FiCoffee, FiMessageSquare, FiTwitter } from 'react-icons/fi'
import Anchor from '~/components/Anchor'
import Container from '~/components/Container'
import News from '~/components/News'

const TWEETS = [
  '1266490485650198528',
  '1267934678784389121',
  '1246110709005660163',
  '1279431298990379012',
]

export default function Footer() {
  const { t } = useTranslation()

  return (
    <footer className="cb-footer bg-white p-4 shadow">
      <Container size="large">
        <News tweetIds={TWEETS} />
        <div className="cb-footer-meta md:flex md:items-center md:justify-between">
          <p className="text-center md:text-left">
            <span>{t('common:made-by')}</span>
            <Anchor href="https://twitter.com/DuranCristhian" id="my-twitter">
              Cristhian Duran
            </Anchor>
          </p>
          <div className="mt-8 md:mt-0 text-center md:text-left">
            <ul className="md:flex md:items-center md:justify-center">
              <li className="mb-2 md:mb-0 md:mr-4">
                <Anchor
                  href="https://cafecito.app/durancristhian"
                  id="donate"
                  display="block"
                >
                  <span className="flex items-center justify-center">
                    <FiCoffee />
                    <span className="ml-1">{t('common:donate')}</span>
                  </span>
                </Anchor>
              </li>
              <li className="mb-2 md:mb-0 md:mr-4">
                <Anchor
                  href="https://forms.gle/egSBrsKSFnEgabff7"
                  id="feedback-form"
                  display="block"
                >
                  <span className="flex items-center justify-center">
                    <FiMessageSquare />
                    <span className="ml-1">{t('common:feedback-form')}</span>
                  </span>
                </Anchor>
              </li>
              <li>
                <Anchor
                  href="https://twitter.com/corona_bingo"
                  id="coronabingo-twitter"
                  display="block"
                >
                  <span className="flex items-center justify-center">
                    <FiTwitter />
                    <span className="ml-1">
                      {t('common:coronabingo-twitter')}
                    </span>
                  </span>
                </Anchor>
              </li>
            </ul>
          </div>
        </div>
      </Container>
    </footer>
  )
}
